import React from 'react';
import { createPortal } from 'react-dom';
import { useGraphEditorLayout } from '../context/GraphEditorLayoutContext.js';

/** Move the existing controls, not their state or handlers, into compact chrome. */
export default function GraphEditorChromeSlot({ name, children }) {
  const layout = useGraphEditorLayout();
  const target = layout?.compactChrome && layout.chromeTargets[name];
  return target ? createPortal(children, target) : <>{children}</>;
}
